export const styles = {


  // 1. PAGE LAYOUT
  wrapper: { 
    backgroundColor: '#FDF5E6', 
    color: '#283618', 
    fontFamily: "'Georgia', serif", 
    margin: 0, 
    minHeight: '100vh', 
    overflowX: 'hidden' 
  },
  nav: { 
    display: 'flex', 
    justifyContent: 'flex-start', // Changed from space-between to keep buttons together while scrolling
    padding: '15px 5%', 
    alignItems: 'center', 
    position: 'sticky', 
    top: 0, 
    backgroundColor: 'rgba(253, 245, 230, 0.9)', 
    backdropFilter: 'blur(10px)', 
    zIndex: 100,
    
    // NEW MOBILE SCROLLING PROPERTIES
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    WebkitOverflowScrolling: 'touch', // Smooth momentum for iOS
    msOverflowStyle: 'none',  // Hides scrollbar for IE/Edge
    scrollbarWidth: 'none',   // Hides scrollbar for Firefox
  },
  navButton: {
    flexShrink: 0, // CRITICAL: Prevents buttons from squishing on mobile
    background: 'transparent',
    border: 'none',
    padding: '10px 20px',
    fontSize: '0.8rem',
    letterSpacing: '2px',
    textTransform: 'uppercase',
    color: '#283618',
    cursor: 'pointer',
    fontFamily: "'Georgia', serif",
    opacity: 0.7,
    transition: 'opacity 0.3s ease'
  },
  navButtonActive: {
    opacity: 1,
    fontWeight: 'bold',
    borderBottom: '1px solid #BC6C25'
  },

  bookNowBtn: {
    // 1. THE FOUNDATION
    boxSizing: 'border-box', // CRITICAL: Keeps size identical including border
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '160px',
    height: '45px', // Fixed height prevents vertical jumping
    
    // 2. THE DESIGN
    background: 'transparent',
    border: '1px solid #BC6C25', // Always there, even if invisible
    color: '#BC6C25',
    padding: '0 30px',
    fontSize: '0.8rem',
    fontWeight: '300',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease-in-out, color 0.2s ease-in-out',
    borderRadius: '2px',
    outline: 'none',
  },

  bookNowBtnHover: {
    backgroundColor: '#BC6C25',
    color: '#FCF9F2',
    border: '1px solid #BC6C25', // Matches the non-hover state exactly
  },


  logo: { 
    fontSize: '1.1rem', 
    fontWeight: '300', // Light weight looks more upright
    letterSpacing: '4px', 
    color: '#283618', 
    textTransform: 'none', // Prevents forced uppercase from ruining the serif look
    fontStyle: 'normal' // Explicitly non-italic
  },
  glassBtn: { 
    padding: '10px 22px', 
    backgroundColor: '#556B2F', 
    color: 'white', 
    border: 'none', 
    borderRadius: '50px', 
    cursor: 'pointer', 
    fontSize: '0.75rem', 
    fontWeight: 'bold', 
    textTransform: 'uppercase',
    transition: 'opacity 0.3s'
  },

  // 2. HERO SECTION
  hero: {
    position: 'relative',
    height: '75vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: '0 8%',
  },
  mainTitle: { 
    fontSize: '4.5rem', 
    margin: 0, 
    fontWeight: '400', 
    lineHeight: '1.05',
    color: '#283618'
  },
  italicText: { 
    fontStyle: 'italic', 
    color: '#BC6C25', 
    fontFamily: "'Times New Roman', serif",
    fontWeight: '300'
  },
  heroSub: { 
    fontSize: '0.85rem', 
    color: '#606C38', 
    marginTop: '15px', 
    letterSpacing: '3px', 
    textTransform: 'uppercase' 
  },
  heroActions: { 
    marginTop: '35px', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    gap: '25px' 
  },
  primaryBtn: { 
    padding: '14px 35px', 
    backgroundColor: '#BC6C25', 
    color: 'white', 
    border: 'none', 
    borderRadius: '50px', 
    cursor: 'pointer', 
    fontWeight: 'bold',
    transition: 'transform 0.2s'
  },
  priceTag: { 
    color: '#BC6C25', 
    fontWeight: 'bold', 
    fontSize: '0.9rem',
    letterSpacing: '1px'
  },

  // 3. ABOUT SECTION (Boutique Layout)
  aboutSection: {
    padding: '100px 8%',
    backgroundColor: '#FDF5E6', // Matches your Cream theme
    color: '#283618', // Deep Moss
  },
  aboutContainer: {
    maxWidth: '1100px',
    margin: '0 auto',
  },
  aboutQuote: {
    fontFamily: "'Cormorant Garamond', serif",
    fontSize: '1.9rem',
    fontStyle: 'italic',
    color: '#BC6C25', // Terracotta accent
    textAlign: 'center',
    maxWidth: '800px',
    margin: '0 auto 80px auto',
    lineHeight: '1.4',
  },
  aboutContentGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '60px',
    alignItems: 'start',
  },
  aboutHeading: {
    fontSize: '2.5rem',
    fontWeight: '300',
    marginBottom: '30px',
    letterSpacing: '1px',
    color: '#283618',
  },
  aboutParagraph: {
    fontSize: '1.05rem',
    lineHeight: '1.8',
    fontWeight: '300',
    marginBottom: '20px',
    opacity: 0.9,
  },
  aboutBrandHook: {
    marginTop: '40px',
    fontSize: '1.2rem',
    letterSpacing: '3px',
    fontWeight: '400',
    lineHeight: '1.6',
    textTransform: 'uppercase',
  },
  aboutAccent: {
    color: '#BC6C25',
  },

  // 4. SPECIALTIES SECTION
  specialtiesSection: {
    padding: '100px 8%',
    backgroundColor: '#FEFAE0',
  },
  specialtiesTitle: {
    fontSize: '3rem',
    color: '#283618',
    fontWeight: '300',
    letterSpacing: '1px',
    textAlign: 'center',
    marginBottom: '20px'
  },
  sectionDivider: {
    width: '60px',
    height: '1px',
    backgroundColor: '#BC6C25',
    margin: '0 auto 60px',
    opacity: 0.4
  },
  specialtiesGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto'
  },
  specialtyCard: {
    padding: '50px 35px',
    backgroundColor: 'rgba(255, 255, 255, 0.6)',
    border: '1px solid rgba(188, 108, 37, 0.1)',
    borderRadius: '8px',
    textAlign: 'center',
    transition: 'all 0.3s ease',
  },
  specialtyIcon: {
    fontSize: '2.2rem',
    marginBottom: '25px',
    filter: 'sepia(0.5)',
    opacity: 0.8
  },
  specialtyTitle: {
    fontSize: '1.4rem',
    color: '#BC6C25',
    marginBottom: '8px',
    fontWeight: '600'
  },
  specialtySubtitle: {
    fontSize: '0.75rem',
    textTransform: 'uppercase',
    letterSpacing: '2px',
    color: '#606C38',
    display: 'block',
    marginBottom: '20px'
  },
  specialtyDesc: {
    fontSize: '1rem',
    lineHeight: '1.6',
    color: '#283618',
    opacity: 0.9,
    fontWeight: '300'
  },

  // 7. BOOKING SECTION (Tabbed Scheduler)
  bookingSection: {
    backgroundColor: '#FCF9F2',
    padding: '100px 20px',
  },
  bookingContainer: {
    maxWidth: '1000px',
    margin: '0 auto',
    textAlign: 'center',
  },
  bookingHeading: {
    fontSize: '2.5rem',
    fontWeight: '200',
    letterSpacing: '4px',
    marginBottom: '10px',
    color: '#283618',
    textTransform: 'uppercase'
  },
  bookingSub: {
    fontSize: '0.9rem',
    marginBottom: '50px',
    opacity: 0.7,
    letterSpacing: '1px'
  },
  bookingMenu: {
    display: 'flex',
    justifyContent: 'center',
    gap: '40px',
    marginBottom: '60px',
    borderBottom: '1px solid #E0E0E0'
  },
  bookingTab: {
    background: 'none',
    border: 'none',
    borderBottom: '2px solid transparent',
    color: '#283618',
    padding: '15px 10px',
    cursor: 'pointer',
    letterSpacing: '3px',
    fontWeight: '200',
    opacity: 0.4,
    transition: 'all 0.3s ease',
    fontSize: '0.8rem'
  },
  bookingTabActive: {
    borderBottom: '2px solid #BC6C25',
    opacity: 1,
    fontWeight: '400',
  },
  calendarWrapper: {
    borderRadius: '4px',
    overflow: 'hidden',
    boxShadow: '0 10px 40px rgba(0,0,0,0.03)',
    backgroundColor: '#ffffff'
  },
  
  // 5. REVIEWS SECTION
  reviewsSection: { padding: '100px 8%', backgroundColor: '#FDF5E6' },
  reviewNavigationWrapper: { 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    gap: '30px', 
    maxWidth: '1000px', 
    margin: '0 auto' 
  },
  arrowBtn: { 
    backgroundColor: 'transparent', 
    border: '1px solid #BC6C25', 
    color: '#BC6C25', 
    borderRadius: '50%', 
    width: '50px', 
    height: '50px', 
    cursor: 'pointer', 
    fontSize: '1.2rem', 
    display: 'flex', 
    alignItems: 'center', 
    justifyContent: 'center', 
    transition: 'all 0.3s ease',
    opacity: 0.6
  },
  reviewCard: { 
    backgroundColor: 'white', 
    padding: '60px', 
    borderRadius: '4px', // More elegant/sharp look
    boxShadow: '0 4px 20px rgba(0,0,0,0.02)',
    borderTop: '1px solid #f0f0f0',
    minHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    textAlign: 'center'
  },
  reviewTag: { 
    color: '#BC6C25', 
    fontSize: '0.7rem', 
    fontWeight: 'bold', 
    textTransform: 'uppercase', 
    letterSpacing: '2px', 
    marginBottom: '20px' 
  },
  reviewText: { 
    fontSize: '1.2rem', 
    fontStyle: 'italic', 
    lineHeight: '1.8', 
    color: '#283618', 
    marginBottom: '25px',
    fontWeight: '300'
  },
  reviewAuthor: { 
    fontSize: '0.9rem', 
    color: '#606C38', 
    fontWeight: 'bold',
    letterSpacing: '1px'
  },

  // 6. CTA & FOOTER
// 6. CTA & FOOTER
ctaBanner: { 
  margin: '80px 8%', 
  padding: '80px 40px', 
  backgroundColor: '#556B2F', 
  borderRadius: '20px', 
  textAlign: 'center', 
  color: 'white' 
},
ctaTitle: { 
  fontSize: '2.5rem', 
  marginBottom: '30px', 
  fontWeight: '300',
  lineHeight: '1.2' 
},
bigWhiteBtn: { 
  padding: '18px 45px', 
  backgroundColor: 'white', 
  color: '#556B2F', 
  border: 'none', 
  borderRadius: '50px', 
  fontWeight: 'bold', 
  cursor: 'pointer',
  fontSize: '0.9rem',
  textTransform: 'uppercase',
  transition: 'transform 0.2s ease'
},
footer: { 
  padding: '60px 30px', 
  textAlign: 'center', 
  opacity: 0.5, 
  fontSize: '0.75rem',
  letterSpacing: '1px',
  color: '#283618'
},

flashcardContainer: {
  perspective: '1000px',
  width: '100%',
  height: '140px',
  cursor: 'pointer',
  position: 'relative',
},
flashcardInner: {
  position: 'relative',
  width: '100%',
  height: '100%',
  textAlign: 'center',
  transition: 'transform 0.6s cubic-bezier(0.4, 0, 0.2, 1)',
  transformStyle: 'preserve-3d',
},
// Apply this style when the card is flipped
flashcardFlipped: {
  transform: 'rotateY(180deg)',
},
flashcardFace: {
  position: 'absolute',
  width: '100%',
  height: '100%',
  backfaceVisibility: 'hidden',
  WebkitBackfaceVisibility: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '12px',
  padding: '20px',
  boxSizing: 'border-box',
  boxShadow: '0 4px 15px rgba(0,0,0,0.05)',
},
flashcardFront: {
  backgroundColor: '#ffffff',
  border: '1px solid #E0E0E0',
  color: '#283618',
},
flashcardBack: {
  backgroundColor: '#BC6C25', // Your Terracotta accent
  color: '#ffffff',
  transform: 'rotateY(180deg)',
},
flashcardLabel: {
  fontSize: '0.65rem',
  textTransform: 'uppercase',
  letterSpacing: '2px',
  marginBottom: '10px',
  opacity: 0.6,
},
flashcardWord: {
  fontSize: '1.2rem',
  fontWeight: '400',
  fontFamily: "'Playfair Display', serif",
},
};